import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { InstanceCustomFieldsService } from 'features/custom-fields/instance/instance-custom-fields.service';
import { Observable } from 'rxjs';
import { CustomFields } from 'features/custom-fields';

export const profilePageCustomFieldsResolver: ResolveFn<Observable<CustomFields.ItemInstance[]>> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
) => {
  const profileId = route.parent.params.profileId;
  return inject(InstanceCustomFieldsService).getUserCustomFields(profileId);
};
